import axios from 'axios'

export default {
  async writers (params) {
    // await this.sleep(1500)
    return await axios.get('/api/spa/v1/public-writers', { params })
  },
  async search (params) {
    // await this.sleep(1500)
    return await axios.get('/api/spa/v1/public-writers/search', { params })
  },
  async sleep (ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }
}
